import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';

const c = initContract();

export const DaasSettings = z.object({
});

export const DisplayPreferences = z.object({
  category: z.object({
    displayOrderIds: z.array(z.string())
  })
});

export default c.router({
  getDaaSSettings: {
    method: 'GET',
    path: '/daassettings',
    responses: {
      200: DaasSettings,
      ...failedResponses
    }
  },
  updateDaaSSettings: {
    method: 'PUT',
    path: '/daassettings',
    responses: {
      200: DaasSettings,
      ...failedResponses
    },
    body: z.object({
    })
  },
  getDisplayPreferences: {
    method: 'GET',
    path: '/displaypreference',
    responses: {
      200: DisplayPreferences,
      ...failedResponses
    }
  },
  updateDisplayPreferences: {
    method: 'PUT',
    path: '/displaypreference',
    responses: {
      200: DisplayPreferences,
      ...failedResponses
    },
    body: DisplayPreferences
  }
});
